import { render, staticRenderFns } from "./TheHeaderDropdownMssgs.vue?vue&type=template&id=e6d4fbc4"
import script from "./TheHeaderDropdownMssgs.vue?vue&type=script&lang=js"
export * from "./TheHeaderDropdownMssgs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports